import { render, staticRenderFns } from "./supervise_course.vue?vue&type=template&id=4296f536&scoped=true"
import script from "./supervise_course.vue?vue&type=script&lang=js"
export * from "./supervise_course.vue?vue&type=script&lang=js"
import style0 from "./supervise_course.vue?vue&type=style&index=0&id=4296f536&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4296f536",
  null
  
)

export default component.exports